import React from 'react';
import { Checkbox as HeadlessCheckbox } from '@headlessui/react';
import { cn } from './utils';

export interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  indeterminate?: boolean;
  className?: string;
  name?: string;
  id?: string;
  'aria-label'?: string;
  'aria-labelledby'?: string;
}

export function Checkbox({
  checked,
  onChange,
  disabled,
  indeterminate = false,
  className,
  name,
  id,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
}: CheckboxProps) {
  return (
    <HeadlessCheckbox
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      indeterminate={indeterminate}
      name={name}
      id={id}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      className={cn(
        'bh-checkbox',
        checked && 'bh-checkbox--checked',
        indeterminate && 'bh-checkbox--indeterminate',
        className
      )}
    >
      <svg className="bh-checkbox__icon" viewBox="0 0 12 10" aria-hidden fill="none">
        {indeterminate ? (
          <rect x="1" y="4.25" width="10" height="1.5" rx="0.75" fill="currentColor" />
        ) : (
          <path
            d="M1 5.5L4.5 9L11 1.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        )}
      </svg>
    </HeadlessCheckbox>
  );
}
